<header>
  <div class="b3-header">
    <div class="b3-header-logo-container">
      <b3-logo size="lg" color="primary" aria-label="B3"></b3-logo>
      <span class="b3-header-app-name">Carbono</span>
    </div>
  </div>
</header>
